import { combineEpics } from "redux-observable";

import fetchUserDataEpic from "./epic/index.js";
import updateUserDataEpic from "../../components/WelcomeModal/epic/epic_updateUserData";
import fetchStateDataEpic from "../../components/VisaApplicationChoice/epic";
import {
  fetchUpdateCase,
  fetchSubmitCase,
  fetchDeleteCase,
} from "../../components/Form/epic";

import {
  sendInvitationEpic,
  updateUserRoleEpic,
  acceptInvitationEpic,
  removeUserFromGroupEpic,
  resendInvitationEpic,
  revokeInvitationEpic,
  rejectInvitationEpic,
  createGroupEpic,
  deleteGroupEpic,
} from "../../components/NetworkContainer/epic";

const rootEpic = combineEpics(
  fetchUserDataEpic,
  fetchStateDataEpic,
  fetchUpdateCase,
  fetchSubmitCase,
  fetchDeleteCase,
  updateUserDataEpic,
  sendInvitationEpic,
  updateUserRoleEpic,
  acceptInvitationEpic,
  removeUserFromGroupEpic,
  resendInvitationEpic,
  revokeInvitationEpic,
  rejectInvitationEpic,
  createGroupEpic,
  deleteGroupEpic
);

export default rootEpic;
